import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '', children: [
      {
        path: '', loadComponent: () => import('./get-in-touch.component').then(m => m.GetInTouchComponent),
        data: {
          title: 'KudosHub | Get In Touch',
          description:'Got questions? Contact us at +91 9997100097 or email us at hello@kudoshub.com. Our team is here to help you out at the earliest.',
          keywords: 'email marketing, email list cleaning, web development, mobile apps',
          ogTitle: 'KudosHub | Get In Touch',
          ogDesc: 'Got questions? Contact us at +91 9997100097 or email us at hello@kudoshub.com. Our team is here to help you out at the earliest.',
          ogImage: 'https://kudoshub.com/theme/images/og-images/get-in-touch.webp',
          ogUrl: 'https://kudoshub.com/get-in-touch',
          twitterTitle: 'KudosHub | Get In Touch',
          twitterDesc: 'Got questions? Contact us at +91 9997100097 or email us at hello@kudoshub.com. Our team is here to help you out at the earliest.',
          twitterImage: 'https://kudoshub.com/theme/images/og-images/get-in-touch.webp'
        }
      }
    ]
  }
];
